import React from 'react';
import { Card, Row, Col, Button, UploadFile, Image as AntdImage } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { FileMetadata } from './FileMetadata';
import { IPlanPhoto } from '../../types/plans';

interface FileGridProps {
  fileList: (IPlanPhoto & UploadFile)[];
  onRemove?: (file: UploadFile) => void;
  getActions?: (file: UploadFile, onChange?: (file: UploadFile) => void) => React.ReactNode[];
  onChange?: (file: UploadFile) => void;
  hideMetadata?: boolean;
}

export const FileGrid: React.FC<FileGridProps> = ({
  fileList,
  onRemove,
  getActions = () => [],
  onChange,
  hideMetadata = true,
}) => {
  if (!fileList?.length) return null;

  return (
    <Row gutter={[16, 16]}>
      {fileList.map((file, index) => (
        <Col key={`file-${index}`} xs={24} sm={12} md={8} xxl={6}>
          <Card
            hoverable
            loading={file.status == 'uploading'}
            cover={
              file.status !== 'uploading' && (
                <AntdImage
                  src={
                    file.compressed?.url ||
                    file.url ||
                    (file.originFileObj && URL.createObjectURL(file.originFileObj))
                  }
                  alt={file.name}
                  style={{
                    aspectRatio: '1 / 1',
                    objectFit: 'cover',
                  }}
                />
              )
            }>
            <Row
              gutter={[16, 16]}
              justify="space-between"
              align="middle"
              style={{ textAlign: 'center' }}>
              {!hideMetadata && (
                <Col span={24}>
                  <FileMetadata file={file} onChange={onChange} />
                </Col>
              )}
              {[
                ...getActions(file, onChange),
                <Button
                  key="delete"
                  danger
                  onClick={() => onRemove?.(file)}
                  style={{ width: '100%' }}>
                  <DeleteOutlined />
                </Button>,
              ].map((action, index) => (
                <Col key={`action-${index}`} span={12}>
                  {action}
                </Col>
              ))}
            </Row>
          </Card>
        </Col>
      ))}
    </Row>
  );
};
